module.exports = __webpack_public_path__ + "files/1eb2a1ec017c50fc19095c1130c2c2cb.png";